import { playPhysicalSound, playDigitalSound } from '../../utils/audioPlayer';

// Anti-double global: 1 order = 1 bunyi maks per 10 menit, di semua jalur
// (realtime notif, realtime orders, polling banner). Tanpa ini jalur polling
// menemukan ulang order yang tadi sudah bunyi via realtime → beep ganda.
const SOUNDED_WINDOW_MS = 10 * 60 * 1000;
const soundedAt = new Map<string, number>();

function markSounded(orderId: string): boolean {
  const now = Date.now();
  const last = soundedAt.get(orderId);
  if (last && now - last < SOUNDED_WINDOW_MS) return false;
  soundedAt.set(orderId, now);
  setTimeout(() => {
    if (soundedAt.get(orderId) === now) soundedAt.delete(orderId);
  }, SOUNDED_WINDOW_MS);
  return true;
}

export function playNotificationSound(
  type: string = 'new_order',
  orderId?: string | number,
  cooldownMap?: Map<string, number>,
  eventType?: string,
) {
  if (orderId && cooldownMap) {
    const now = Date.now();
    const key = String(orderId);
    const last = cooldownMap.get(key);
    if (last && now - last < 10000) return;
    cooldownMap.set(key, now);
  }
  // Notifikasi digital ditulis sebagai ORDER_NEW + metadata.event_type
  // 'digital_order_new' (CHECK constraint belum membolehkan DIGITAL_ORDER_NEW)
  // → bunyi ding, bukan cash.
  if (type === 'DIGITAL_ORDER_NEW' || eventType === 'digital_order_new') {
    if (orderId && !markSounded(`d:${orderId}`)) return;
    playDigitalSound().catch(() => {});
  } else if (type === 'ORDER_NEW' || type === 'new_order') {
    if (orderId && !markSounded(`p:${orderId}`)) return;
    playPhysicalSound().catch(() => {});
  } else if (type === 'ORDER_STATUS' || type === 'order_status' || type === 'order_status_change') {
    // Status berubah TETAP bunyi (termasuk [Sistem] batal-duplikat) — pakai ding + dedup 10 mnt.
    if (orderId && !markSounded(`s:${orderId}:${eventType || type}`)) return;
    playDigitalSound().catch(() => {});
  } else if (type === 'SYSTEM_ALERT') {
    // [Sistem] + alert lain tetap bunyi ding.
    if (orderId && !markSounded(`a:${orderId}`)) return;
    playDigitalSound().catch(() => {});
  }
}
